export const NOTIFICATION_TYPE = {
  PUSH_NOTIFICATION: 'PUSH_NOTIFICATION',
  REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
  PIN_NOTIFICATION: 'PIN_NOTIFICATION',
};
